var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-width fill-height d-flex flex-column align-center pa-6"},[_c('h2',[_vm._v("PLACEHOLDER")]),_c('div',[_vm._v("Route path: "+_vm._s(_vm.$route.path))]),_c('div',[_vm._v("Route params: "+_vm._s(_vm.$route.params))])])
}
var staticRenderFns = []

export { render, staticRenderFns }